// src/plugins/nprogress.ts
// Plugin global para barra de progresso no topo da tela (estilo GitHub)

import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

// Configuração do NProgress
// Cores inspiradas no GitHub: azul #0366d6
NProgress.configure({
    // Cor da barra (azul GitHub)
    showSpinner: false, // Remover spinner circular
    trickleSpeed: 200, // Velocidade da animação (ms)
    minimum: 0.08, // Percentual mínimo antes de iniciar
    easing: 'ease', // Tipo de animação
    speed: 400 // Velocidade de conclusão (ms)
});

// Customizar CSS da barra
const style = document.createElement('style');
style.textContent = `
  /* Barra de progresso no topo */
  #nprogress {
    pointer-events: none;
  }

  #nprogress .bar {
    background: #0366d6; /* Azul GitHub */
    position: fixed;
    z-index: 1031; /* Acima de quase tudo */
    top: 0;
    left: 0;
    width: 100%;
    height: 2px; /* Barra fina */
  }

  /* Brilho/glow sutil (opcional) */
  #nprogress .peg {
    display: block;
    position: absolute;
    right: 0px;
    width: 100px;
    height: 100%;
    box-shadow: 0 0 10px #0366d6, 0 0 5px #0366d6;
    opacity: 1.0;
    transform: rotate(3deg) translate(0px, -4px);
  }
`;
document.head.appendChild(style);

export default NProgress;
